<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Users</h1>
        </div>
        <list />
    </vue-scroll>
</template>

<script>
import List from "./user/List";

export default {
    components: {
        List,
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
